/* src/components/HorizontalScroll/HorizontalScroll.jsx */
import { Children } from 'react'
import './HorizontalScroll.css'
import { useMediaQuery } from "../../hooks/useMediaQuery.js";
import { useHorizontalScroll } from "../../hooks/useHorizontalScroll.js";
import { PanelStatusContext } from "./panelStatus.js";

/**
 * Обгортка з ефектом горизонтального скролу на десктопі.
 * Кожен прямий дочірній елемент стає повноекранною панеллю.
 *
 * Кожна панель отримує через контекст свій статус відносно активної секції
 * ('before' | 'active' | 'after' | 'static') — панелі керують своїми
 * анімаціями входу/виходу саме за цим, а не вгадують стан із власного rect.
 *
 * Мобілка (<1024px) або prefers-reduced-motion → звичайний вертикальний стек.
 */
export function HorizontalScroll({ children }) {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)')
  const enabled = isDesktop && !reducedMotion

  const { sectionRef, trackRef, active, settled } = useHorizontalScroll({ enabled })

  return (
      <section className="hscroll" data-enabled={enabled} ref={sectionRef}>
        <div className="hscroll__viewport">
          <div className="hscroll__track" ref={trackRef}>
            {Children.map(children, (child, i) => {
              const status = !enabled
                  ? 'static'
                  : i < active
                      ? 'before'
                      : i > active
                          ? 'after'
                          : settled
                              ? 'active'
                              : 'after'

              return (
                  <div className="hscroll__panel" key={i}>
                    <PanelStatusContext.Provider value={status}>
                      {child}
                    </PanelStatusContext.Provider>
                  </div>
              )
            })}
          </div>
        </div>
      </section>
  )
}